import { defineComponent } from "vue";
import { getConfig } from "./component-library2.mjs";
import { addCdnHost } from "./component-library104.mjs";
const processSrcset = (srcset) => {
  if (!srcset)
    return void 0;
  const entries = srcset.split(", ");
  const processedEntries = entries.map((entry) => {
    const trimmedEntry = entry.trim();
    const [url, width] = trimmedEntry.split(" ");
    const newUrl = addCdnHost(url);
    return `${newUrl} ${width}`;
  });
  return processedEntries.join(", ");
};
const _sfc_main = defineComponent({
  props: {
    src: { type: String, required: true },
    imageClass: { type: String, default: "" },
    imageStyle: { type: String, default: "" },
    alt: { type: String, default: "" },
    // background images are allowed to have no alt.
    lazy: { type: Boolean },
    format: { type: String, default: "webp" },
    doNotConvert: { type: Boolean },
    sizes: {
      type: String,
      // "sm:100vw md:50vw lg:400px" https://v0.image.nuxtjs.org/components/nuxt-img#sizes
      default: ""
    },
    preload: { type: Boolean }
  },
  emits: ["image-error"],
  head() {
    var _a, _b;
    if (this.preload && ((_a = this.defaultImage) == null ? void 0 : _a.src)) {
      return {
        link: [
          {
            rel: "preload",
            as: "image",
            href: ((_b = this.defaultImage) == null ? void 0 : _b.src) || ""
          }
        ]
      };
    }
    return {};
  },
  computed: {
    defaultImage() {
      const { imageOptimizer } = getConfig() || {};
      if (this.doNotConvert || !imageOptimizer || !this.src || !this.sizes) {
        return {
          src: addCdnHost(this.src),
          type: `image/${this.format}`,
          sizes: void 0,
          srcset: void 0
        };
      }
      const { srcset, sizes, src } = imageOptimizer(this.src, {
        sizes: this.sizes,
        modifiers: {
          format: this.format
        }
      });
      return {
        src: addCdnHost(src),
        type: `image/${this.format}`,
        sizes,
        srcset: processSrcset(srcset)
      };
    }
  }
});
export {
  _sfc_main as default
};
